@let appCommonCopy = cmsService.appCommonPageCopy();
@if (appCommonCopy) {
  @let robynByFeazelImageColor =
    appCommonCopy.images?.['robynByFeazelColor']?.desktopImage;
  @let robynByFeazelImage =
    appCommonCopy.images?.['robynByFeazel']?.desktopImage;
  <div style="z-index: 1050">
    <div
      #fabMenu
      class="contact-fab-menu d-flex flex-column gap-2"
      [class.is-open]="isFabOpen()"
      [class.expand-up]="expandDirection() === 'up'"
      [class.expand-down]="expandDirection() === 'down'"
      [style.pointer-events]="isFabOpen() ? '' : 'none'"
    >
      <div class="menu-header d-flex justify-content-between item">
        @if (robynByFeazelImageColor) {
          <img
            class="robyn-logo mb-2"
            [src]="robynByFeazelImageColor.url"
            [alt]="robynByFeazelImageColor.altText"
          />
        }
        <i
          class="fa-sharp fa-light fa-xmark"
          aria-hidden="true"
          (click)="close()"
        ></i>
      </div>

      <button
        type="button"
        class="btn contact-fab-btn item fw-semibold"
        [class.close]="!isFabOpen() && !skipCloseAnimation()"
        (click)="openContact('call')"
        aria-label="Call"
      >
        <i class="fa-sharp fa-solid fa-phone" aria-hidden="true"></i>
        Call Me
      </button>

      <button
        type="button"
        class="btn contact-fab-btn item fw-semibold"
        [class.close]="!isFabOpen() && !skipCloseAnimation()"
        (click)="openContact('text')"
        aria-label="Text"
      >
        <i class="fa-sharp fa-solid fa-comments" aria-hidden="true"></i>
        Text Me
      </button>

      <button
        type="button"
        class="btn contact-fab-btn item fw-semibold"
        [class.close]="!isFabOpen() && !skipCloseAnimation()"
        (click)="openContact('email')"
        aria-label="Email"
      >
        <i class="fa-sharp fa-solid fa-envelope" aria-hidden="true"></i>
        Email Me
      </button>
    </div>

    <button
      #fabBtn
      type="button"
      class="btn btn-primary main-btn"
      (click)="openAt(fabBtn)"
      [attr.aria-label]="
        isFabOpen() ? 'Close contact menu' : 'Open contact menu'
      "
    >
      @if (robynByFeazelImage) {
        <img
          class="robyn-logo"
          [src]="robynByFeazelImage.url"
          [alt]="robynByFeazelImage.altText"
        />
      }
      Contact Me
    </button>
  </div>
}
